
import api from '@/api'
import { _types } from './constant'

const state = {
	plans: null,
    trial: null,
    imagePlans: null
};

const getters = {
    [_types.getters.GET_PLANS](state){
		return state.plans
	},
	[_types.getters.GET_TRIAL](state){
		return state.trial
    },
    [_types.getters.GET_IMAGE_PLANS](state){
		return state.imagePlans
	}
};

const actions = {
    async [_types.actions.GET_PLANS]({commit}){
		try {
            let res =  await api.getPlans();
            let { status , data } = res.data
            if( status ){
                commit(_types.mutations.SET_PLANS, data )
            }
            return res
		} catch (error) {
			throw error;
		}
    },
    async [_types.actions.HANDLE_CHARGE_PLAN]({}, payload){
		try {
			return await api.handleChargePlan(payload);
		} catch (error) {
			throw error;
		}
	},
	async [_types.actions.CREATE_DISCOUNT]({}, payload){
		try {
			return await api.createDiscount(payload);
		} catch (error) {
			throw error;
		}
	},
	async [_types.actions.CHECK_DISCOUNT]({}, payload){
		try {
			return await api.checkDiscount(payload);
		} catch (error) {
			throw error;
		}
	},
	async [_types.actions.GET_TRIAL]({commit}){
		try{
			let res = await api.getTrial();
			let {status, data} = res.data;
			if (status){
				commit(_types.mutations.SET_TRIAL, data)
			}
		}catch (error){
			throw error;
		}
    },
    async [_types.actions.GET_IMAGE_PLANS]({commit}){
       try {
            let res =  await api.getImagePlans();
            let { status , data } = res.data
            if( status ){
                commit(_types.mutations.SET_IMAGES_PLANS, data )
            }
            return res
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.BUY_MORE_IMAGES]({}, payload){
        try {
            return await api.buyMoreImages(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.UPDATE_PRICING_VERSION]({}, payload){
        try {
            return await api.updatePricingVersion(payload);
        } catch (error) {
            throw error;
        }
    }
};

const mutations = {
    [_types.mutations.SET_PLANS](state, payload = null){
		if (payload.essential) {
			payload.essential['is_hightlighted'] = true
		}
		// delete payload['free']
		state.plans = payload
	},
	[_types.mutations.SET_TRIAL](state, payload = null){
		state.trial = payload
    },
    [_types.mutations.SET_IMAGES_PLANS](state, payload = null){
		state.imagePlans = payload
	}
};
export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true,
};
